import {
  getWidthViewportSelect,
  isMobileScreenViewportSelect
} from 'modules/viewport/selectors/index.js'
import { createSelector } from 'reselect'
import { clampNumberUtil } from 'utils/number/index.js'

export const getListWidthAppSelect = createSelector(
  isMobileScreenViewportSelect,
  getWidthViewportSelect,
  (isMobileScreen, viewportWidth) => {
    if (isMobileScreen) {
      return viewportWidth - 32
    }

    return clampNumberUtil(viewportWidth - 32, 0, 500)
  }
)
